<div class="container" style="background-color: #fff;">
    <!--        <app-main-image *ngIf="item" [product]="item"-->
    <!--        ></app-main-image>-->
    <div class="row">
        <div class="col-md-6 col-sm-12">
            <div class="pl-2 pt-2 pb-2 pr-2"><a routerLink="/panel/360/{{pcode}}" class="">Back to Panel Products</a></div>

            <img src="{{item.getImage()}}" class="img-fluid hover-shadow cursor" class="img-fluid"/>
        </div>

        <div class="col-md-6 col-sm-12 p-4">  <app-product-information *ngIf="item" [product]="item"></app-product-information></div>

    </div>
</div>

